import { Pipe, PipeTransform } from '@angular/core';
import { SigIdPaymentComponentRead } from '../../../services/sig-id.common.model';
import { calcItemTotalAmount } from './item-total-amount.pipe';

export function calcTotalAmount(data?: SigIdPaymentComponentRead[]): number {
  let result = 0;
  data?.forEach(v => {
    result = calcItemTotalAmount(v) + result;
  });
  return result;
}

@Pipe({
  name: 'totalAmount',
  standalone: true,
  pure: false
})
export class TotalAmountPipe implements PipeTransform {

  transform(value?: SigIdPaymentComponentRead[] | null): number {
    return calcTotalAmount(value || []);
  }

}
